module.exports = __webpack_public_path__ + "static/new-project.87990bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/learn/new-project.png
// module id = 1156
// module chunks = 127651196306611